export const LOCAL_STORAGE_ACCESS_TOKEN = 'infohidro:token';
export const LOCAL_STORAGE_SEARCHED_CAPTATIONS_POINTS ='infohidro-searched-captations-points';
export const LOCAL_STORAGE_SEARCHED_EFFLUENTS_POINTS ='infohidro-searched-effluents-points';
export const LOCAL_STORAGE_MODAL_MAP_INFO ='infohidro-modal-map-info';
